<template>
  <div class="form-footer">
    
    <slot />

    <button @click="formSubmit" class="action-btn" :class="classProp">
      <span v-show="!loading">{{ buttonText }}</span>
      <ClipLoader :loading="loading" :color="'#fff'" :size="'20px'"></ClipLoader>
    </button>
  </div>
</template>

<script>
  import ClipLoader from 'vue-spinner/src/ClipLoader';
  
  export default {
    name: "FPInputButton",
    components: {
      ClipLoader
    },
    props: {
      buttonText: {
        type: String,
        required: true
      },
      loading: {
        type: Boolean,
        required: true
      },
      classProp: {
        type: String,
        required: false,
        default: ''
      }
    },
    methods: {
      // Upon form submit emit to parent to call the onSubmit... function
      formSubmit () {
        this.$emit('formSubmit')
      }
    }
  }
</script>
